import CityPageTemplate from "../city-template/CityPageTemplate";
import { brunswickConfig } from "./data";

export default function BrunswickPage() {
  return <CityPageTemplate config={brunswickConfig} />;
}